export function titleCase(input) {
    return input.toLowerCase().split(' ').map(function (word) {
        return firstCharUpperCase(word);
        // return word.replace(word[0], word[0].toUpperCase());
    }).join(' ');
}

export function firstCharUpperCase(input, lowercaseOthers) {
    if(lowercaseOthers){
        input = input.toLowerCase();
        return input.replace(input[0], input[0].toUpperCase());
    }
    return input.replace(input[0], input[0].toUpperCase());
}